// extracted by mini-css-extract-plugin
export default {"no_companies_wrapper":"NoCompanies_no_companies_wrapper__C0LOm","no_companies_link":"NoCompanies_no_companies_link__Xzv-M"};